import React, { FC } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { IProductLabel } from 'api/types';
import Label from 'components/controls/Label';

interface IProps {
  labels: IProductLabel[];
  className?: string;
}

const LabelsList: FC<IProps> = ({ labels, className }) => {
  if (!labels || labels.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {labels.map((label, index) => (
        <Tooltip key={`${label.type}-${index}`} title={label.name || label.type} placement="top" arrow>
          <span style={{ display: 'inline-block' }}>
            <Label label={label} />
          </span>
        </Tooltip>
      ))}
    </div>
  );
};

export default LabelsList;

